const hashReplace = [
  {
    value: '/auth/yoga-alliance',
    replaceValue: '/signup/yoga-alliance',
  },
  {
    value: '/auth/signin/',
    replaceValue: '/buy/product/',
  },
  {
    value: '/auth/signin',
    replaceValue: '/login',
  },
  {
    value: '/auth',
    replaceValue: '',
  },
  {
    value: '/join/info',
    replaceValue: '',
  },
  {
    value: '/products/all',
    replaceValue: '/shop',
  },
  {
    value: '/event/all',
    replaceValue: '/calendar',
  },
  {
    value: '/about/info',
    replaceValue: '/shop',
  },
  {
    value: '/auth/signup',
    replaceValue: '/signup',
  },
];

function replaceAngularUrls(to) {
  let path = to.hash;
  if (path.includes('#/')) {
    const replace = hashReplace.find(({ value }) => path.includes(value));
    if (replace) path = path.replace(replace.value, replace.replaceValue);
    path = path.replace('#/', '');
    return {
      path: path,
      query: to.query,
    };
  }
}

export { replaceAngularUrls };
